module.exports = __webpack_public_path__ + "static/img/eggebracht.dc9aff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/eggebracht.png
// module id = zhvc
// module chunks = 0